import React from "react";
import { compose } from "helper/compose";
import { withTranslation, type WithTranslation } from "react-i18next";
import { Alert, Button, Form, FormField, PasswordInput, TextInput } from "../../ui";

interface FormErrorItem {
  code: string;
  message: string;
}

interface NewPasswordFormProps extends WithTranslation {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  formError?: FormErrorItem[];
}

function NewPasswordForm({ t, onChange, onSubmit, formError }: NewPasswordFormProps) {
  const emailId = "NewPasswordForm-email";
  const passwordId = "NewPasswordForm-password";
  const passwordConfirmId = "NewPasswordForm-passwordConfirm";
  const formErrorId = "NewPasswordForm-errors";

  return (
    <Form action="/" onSubmit={onSubmit} className="Form LoginForm NewPasswordForm" noValidate>
      {formError && formError.length > 0 ? (
        <Alert variant="error" className="Form-message error" id={formErrorId}>
          {formError.map((error) => (
            <span key={error.code} className="Form-messageLine">
              {error.message}
            </span>
          ))}
        </Alert>
      ) : null}
      <FormField
        className="Form-line"
        label={t("password.new.email")}
        htmlFor={emailId}
        hint={t("password.new.info_email")}
      >
        <TextInput
          className="Form-input LoginForm-email"
          type="email"
          name="email"
          id={emailId}
          onChange={onChange}
          aria-describedby={[formError?.length ? formErrorId : null].filter(Boolean).join(" ")}
        />
      </FormField>
      <FormField
        className="Form-line"
        label={t("password.new.password")}
        htmlFor={passwordId}
        hint={t("password.new.info_password")}
      >
        <PasswordInput
          className="Form-input LoginForm-password"
          name="password"
          id={passwordId}
          onChange={onChange}
          aria-describedby={[formError?.length ? formErrorId : null].filter(Boolean).join(" ")}
        />
      </FormField>
      <FormField
        className="Form-line"
        label={t("password.new.check_password")}
        htmlFor={passwordConfirmId}
      >
        <PasswordInput
          className="Form-input LoginForm-passwordConfirm"
          name="passwordConfirm"
          id={passwordConfirmId}
          onChange={onChange}
          aria-describedby={formError?.length ? formErrorId : undefined}
        />
      </FormField>
      <div className="Form-line isActionLine">
        <Button type="submit" size="lg" className="Button LoginForm-submit isLarge">
          {t("common.button_register")}
        </Button>
      </div>
    </Form>
  );
}

export default compose(withTranslation())(NewPasswordForm);
